import { HtmlComponent } from './html-component';
import * as Snap from 'snapsvg-cjs';

export interface IResource {
    name: string;
    path: string;
}

export abstract class ResourceLoader extends HtmlComponent {
    private resources: any;
    private snapResourceLoader: any;

    constructor(hogan: any, parameters: {}, resourceDefinitions: IResource[]) {
        super(hogan, parameters);
        this.snapResourceLoader = Snap('#resource-loader');
        this.loadResources(resourceDefinitions);
    }

    public loadResources(resourceDefinitions: IResource[]) {
        this.resources = {};
        for (let r of resourceDefinitions) {
            this.resources[r.name] = null;
        }

        for (let r of resourceDefinitions) {
            Snap.load(r.path, (svgFragment: any) => {
                this.resources[r.name] = this.wrapInGroup(svgFragment);
            });
        }
    }

    public retrieveSymbol(svgSymbolName: string) {
        const svgSymbol = this.resources[svgSymbolName];
        this.snapResourceLoader.append(svgSymbol);
        const clone = svgSymbol.clone();
        svgSymbol.remove();
        return clone;
    }

    protected areResourcesLoaded() {
        let isNull = true;
        Object.keys(this.resources).forEach((k: string) => {
            const el: any = this.resources[k];
            if (!el) {
                isNull = false;
            }
        });
        return isNull;
    }

    private wrapInGroup(element: any) {
        const svgSymbol = this.snapResourceLoader.group();
        svgSymbol.append(element);
        svgSymbol.remove();
        return svgSymbol;
    }
}
